import React from 'react';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import './SortableTh.css';

/**
 * A clickable table header cell for server-side sorting.
 *
 * Hovering a SortableTh changes the cursor to a pointer (and underlines the
 * label) so it's visually distinct from plain, non-sortable <th> cells.
 * Clicking calls `onSort(field)`; the parent toggles direction and re-fetches.
 *
 * @param {string} label   - visible header text
 * @param {string} field   - backend field name sent as `?sort=<field>`
 * @param {string} sort    - the currently active sort field
 * @param {string} order   - current direction, 'asc' | 'desc'
 * @param {(field: string) => void} onSort - click handler
 * @param {string} [className]
 */
const SortableTh = ({ label, field, sort, order, onSort, className = '' }) => {
    const active = sort === field;

    const icon = active
        ? order === 'asc'
            ? <FaSortUp className='sortable-th__icon' />
            : <FaSortDown className='sortable-th__icon' />
        : <FaSort className='sortable-th__icon sortable-th__icon--muted' />;

    return (
        <th
            className={`sortable-th ${active ? 'sortable-th--active' : ''} ${className}`.trim()}
            onClick={() => onSort(field)}
            role='button'
            aria-sort={active ? (order === 'asc' ? 'ascending' : 'descending') : 'none'}
            title={`Sort by ${label}`}
        >
            {label}
            {icon}
        </th>
    );
};

export default SortableTh;
